<template>
  <PageWrapper
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_MY_DRAFT_PUBLICATIONS"
    title="Draft Publications"
    :breadcrumbs="breadcrumbs"
    page-name="Draft Publications"
    align="left"
    width="full"
    action-button-text="Create New Publication"
    @click:action="navigateToCreatePublication"
  >
    <SmartFeed
      :pinia-store="useDraftPublicationFeedStore"
      default-entity-layout="cardSmall"
      default-smart-feed-layout="grid"
      load-more-behavior="auto"
    />
  </PageWrapper>
</template>

<script>
import { mapState } from "pinia";
import PageWrapper from "@/components/PageWrapper.vue";
import SmartFeed from "SmartFeed/components/SmartFeed";
import { PAGE_MY_DRAFT_PUBLICATIONS, SECTION_PUBLICATIONS } from "@/constants/nav-constants";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { useDraftPublicationFeedStore } from "SmartFeed/stores/feed/draft-publication-feed-store";

export default {
  name: "MyDraftPublications",
  components: {
    SmartFeed,
    PageWrapper,
  },
  provide: {
    hideBadge: true,
  },
  data() {
    return {
      SECTION_PUBLICATIONS,
      PAGE_MY_DRAFT_PUBLICATIONS,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, [
      "orgId",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
      ];
    },
  },
  methods: {
    useDraftPublicationFeedStore,
    navigateToCreatePublication() {
      window.location = `/publication/org/${this.orgId}/create`;
    },
  },
};
</script>
